import cloneDeep from 'lodash/cloneDeep'
import { store } from '@/store'
import router from '@/router'
import { BaseRouteEnum, SetupGuideEnum } from '@/enums/modules/routes'
import IntegrationsEnum from '@/enums/modules/integrations'
import ShipbobAppSettings from '@/appSettings/appSetting'

const BLACK_LIST_ROUTES = ['/app/indexv2/', '/app/indexv2', '/app/index/', '/app/index', '/app/merchant/#/onboarding']

const isLocalUrl = (url) => /^\/[^\/\\]/.test(url) // eslint-disable-line

const isInBlackList = (url) => BLACK_LIST_ROUTES.includes(url.toLowerCase())

const extractReturnUrl = (route) => {
  const returnUrl = route.query && route.query.ReturnUrl
  if (!returnUrl || isInBlackList(returnUrl) || !isLocalUrl(returnUrl)) return undefined
  return returnUrl
}

const extractStoreLink = (route) => {
  if (!route.query) return null
  const { type, code } = route.query
  if (type && code && type === IntegrationsEnum.shopify) return IntegrationsEnum.shopify
  return null
}

const cachedRouteStrategy = (cachedRoute) => ({
  execute: () => {
    router.push(cloneDeep(cachedRoute))
    store.dispatch('clearCachedRoute')
  }
})

const returnUrlStrategy = (returnUrl) => ({
  execute: () => window.location.replace(returnUrl)
})

const defaultStrategy = () => ({
  execute: () => router.push({ name: BaseRouteEnum.Dashboard })
})

const storeLinkStrategy = (storeType) => {
  // redirecting with a full page reload because after register we do not have the full user object from fetchLoggedInAndImpersonatedBasicUserData
  // reloading the window causes that fetch to happen properly
  if (storeType === IntegrationsEnum.shopify) return { execute: () => { window.location.href = '/app/Merchant/#/IntegrationsManagement?platformSource=shopify&newInstall=true' } }
  if (storeType === IntegrationsEnum.amazon) return { execute: () => { window.location.href = '/Home/QuickSetup' } }
  return defaultStrategy()
}

export const handleRedirect = (currentRoute, withReload = false) => {
  const returnUrl = extractReturnUrl(currentRoute)
  const cachedRoute = store.state.cachedRoute
  const storeLink = extractStoreLink(currentRoute)
  let redirectStrategy
  if (cachedRoute) redirectStrategy = cachedRouteStrategy(cachedRoute)
  else if (returnUrl) redirectStrategy = returnUrlStrategy(returnUrl)
  else if (storeLink) redirectStrategy = storeLinkStrategy(storeLink)
  else redirectStrategy = defaultStrategy(withReload)
  redirectStrategy.execute()
}

export const encodeAndStoreReturnUrl = (route) => {
  store.dispatch('cacheRoute', route)
  var redirectUrl = SetupGuideEnum.Login
  if (route.query && route.query.utm_source) {
    redirectUrl = SetupGuideEnum.SignUp
  }
  return { name: redirectUrl, query: { ReturnUrl: ShipbobAppSettings.vueRouterBase + '#' + route.fullPath, ...route.query } }
}
